import { colors } from '@resurs/midas'
import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { Switch, Columns, Column, TextInput } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import CurrencyInput from '../../../../internal/CurrencyInput'
import CardInformationSelect from '../shared/CardInformationSelect'
import { CustomerTypeModel } from '../../models/private-models'
import { PaymentMethods } from '../../../../models/payment-methods'

const DebitPayment = ({
  debitPaymentChecked,
  isValid,
  onDebitPaymentSwitch,
  onChangeAmount,
  debitReference,
  onChangeDebitReference,
  disabled,
  minPurchaseLimit,
  maxPurchaseLimit,
  autoFocus,
  availableCards,
  selectedCard,
  onChangeCard,
  selectedPaymentMethod,
  debitUnavailableReason,
  hideDebitReference,
}) => {
  return (
    <div>
      <Switch
        key="debit_{selectedPaymentMethod.id}"
        id="debit_{selectedPaymentMethod.id}"
        text={getText('payApply.paymentMethod.debitText')}
        boldText
        checked={debitPaymentChecked}
        onChange={e => onDebitPaymentSwitch(e.target.checked)}
        disabled={disabled}
      />
      {(debitPaymentChecked && (
        <Columns>
          <Column col6>
            <Conditional
              when={
                !!selectedPaymentMethod &&
                selectedPaymentMethod.customerType ===
                  CustomerTypeModel.LEGAL &&
                selectedPaymentMethod.type === PaymentMethods.RESURS_CARD
              }
            >
              <CardInformationSelect
                customerType={CustomerTypeModel.LEGAL}
                availableCards={availableCards}
                selectedCard={selectedCard}
                onChangeCard={cardNumber => onChangeCard(cardNumber)}
                hideMasked
              />
            </Conditional>
            <CurrencyInput
              allowDecimals
              autoFocus={autoFocus}
              id="debit-amount"
              label={getText('payApply.paymentMethod.amountLabel')}
              disabled={disabled}
              isValid={validation => isValid(validation)}
              onValueChange={val => onChangeAmount(val.value)}
              boundaries={{
                min: {
                  value: Math.max(1, minPurchaseLimit),
                  error: getText('payApply.paymentMethod.creditToSmall'),
                },
                max: {
                  value: maxPurchaseLimit,
                  error: getText('payApply.paymentMethod.newCreditNeededText'),
                },
              }}
            />
            <Conditional when={!hideDebitReference}>
              <TextInput
                id="debit-reference"
                disabled={disabled}
                label={getText('payApply.paymentMethod.referenceLabel')}
                onChange={e => onChangeDebitReference(e.target.value)}
                value={debitReference}
                skipValidation
              />
            </Conditional>
          </Column>
        </Columns>
      )) ||
        (debitUnavailableReason && (
          <Columns>
            <Column col9 colMd12>
              <p style={{ color: colors.red, margin: 0 }}>
                {debitUnavailableReason}
              </p>
            </Column>
          </Columns>
        ))}
    </div>
  )
}

DebitPayment.propTypes = {
  minPurchaseLimit: PropTypes.number,
  maxPurchaseLimit: PropTypes.number,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  debitPaymentChecked: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  onDebitPaymentSwitch: PropTypes.func.isRequired,
  onChangeAmount: PropTypes.func.isRequired,
  debitReference: PropTypes.string,
  onChangeDebitReference: PropTypes.func.isRequired,
  selectedPaymentMethod: PropTypes.object,
  selectedCard: PropTypes.object,
  availableCards: PropTypes.array,
  onChangeCard: PropTypes.func,
  debitUnavailableReason: PropTypes.string,
  hideDebitReference: PropTypes.bool,
}

DebitPayment.defaultProps = {
  minPurchaseLimit: null,
  maxPurchaseLimit: null,
  autoFocus: false,
  debitReference: '',
  selectedPaymentMethod: null,
  selectedCard: null,
  availableCards: [],
  onChangeCard: null,
  debitUnavailableReason: '',
  hideDebitReference: false,
}

export default DebitPayment
